const labraApiHostPrefixByEnv = {
  qa: 'qa.',
  q1: 'qa.',
  q2: 'qa.',
  stg: 'stg.',
  prd: '',
} as const

export const getServiceUrl = (service: string, env: string) => {
  const sub =
    labraApiHostPrefixByEnv[env as keyof typeof labraApiHostPrefixByEnv] ?? ''
  return `https://${sub}api.labra.io/${service}`
}
